import { FormGroup } from '@angular/forms';
import { IconModel } from '../../pg-icon/icon-model';
import { BehaviorModel } from '../../core/models/behavior-model';
import { ButtonStyles } from '../button-styles';

// Buttons are very interactive components
// Their state changes and actions often rely on code context
// I need to do research to see how to model buttons.
export abstract class ButtonModel implements ButtonStyles {
  id?: string;
  type?: string;
  size?: string;
  formGroup?: FormGroup;
  onClick?: BehaviorModel[];
  onClickTarget?: string;
  loadOnClick?: string;
  disableScaleOnClick?: boolean;
  disableIfFormInvalid?: boolean;
  loading?: boolean;
  color?: string;

  label?: string;

  leftIcon?: IconModel;
  rightIcon?: IconModel;

  backgroundColorIdle?: string;
  backgroundColorHover?: string;
  backgroundColorPressed?: string;
  foregroundColorIdle?: string;
  foregroundColorHover?: string;
  foregroundColorPressed?: string;
  borderRadius?: number;
  boxShadow?: string;
  fontWeight?: number;
  fontFamily?: string;
  height?: number;

  // WIDTH NOT YET IMPLENENTED!!!!
  // TOO MUCH COMPLEXITY IF NOT DEEMED ABSOLUTELY NECESSARY
  width?: string;
}
